export default __webpack_public_path__ + "static/media/icon-head-mavric.48cf72b2.png";